import { render, staticRenderFns } from "./MatRequireMonthPlanList.vue?vue&type=template&id=85ec841e&"
import script from "./MatRequireMonthPlanList.vue?vue&type=script&lang=js&"
export * from "./MatRequireMonthPlanList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports